import { Wallet as EthersWallet } from '@ethersproject/wallet';

export class Wallet extends EthersWallet {}
